export function BootOverlay() {
  return (
    <div id={"kuni-boot-overlay"} hidden role={"status"} aria-live={"polite"} aria-busy={"true"}>
      <div class={"kuni-boot-orb"} aria-hidden={"true"}>
        {"✦"}
      </div>
      <strong id={"kuni-boot-title"}>
        {"Открываем kUni…"}
      </strong>
      <span id={"kuni-boot-text"}>
        {"Подтягиваем сессию — без экрана входа."}
      </span>
    </div>
  );
}
